/**
 * @generated SignedSource<<8db0a9b5edd3c7aff377acabe1cc0b6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserProfileFragment$data = {
  readonly avatar: {
    readonly downloadUrl: string | null;
    readonly thumbnailUrl: string | null;
  } | null;
  readonly id: string;
  readonly username: string;
  readonly " $fragmentType": "UserProfileFragment";
};
export type UserProfileFragment$key = {
  readonly " $data"?: UserProfileFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfileFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserProfileFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorageObjectNode",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbnailUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "downloadUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNode",
  "abstractKey": null
};

(node as any).hash = "3269154babc6e07569fe8514a7234238";

export default node;
